require('./bootstrap');


import Vue from 'vue'
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

// ikonice (jednu po jednu)
import faPhone from '@fortawesome/fontawesome-free-solid/faPhone';
import faMobile from '@fortawesome/fontawesome-free-solid/faMobile';
import faHome from '@fortawesome/fontawesome-free-solid/faHome';
import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope';

fontawesome.library.add(faPhone);
fontawesome.library.add(faMobile);
fontawesome.library.add(faHome);
fontawesome.library.add(faEnvelope);

Vue.component('font-awesome-icon', FontAwesomeIcon);
import Slick from 'vue-slick';

new Vue({
    el: '#header',
    name: 'Header'
});

new Vue({
    el: '#footer',
    name: 'Footer'
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js